import React, { useState } from "react";
import "./Navbar.css";

function Navbar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const handleMenuToggle = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const handleDropdownToggle = (event) => {
    event.preventDefault(); // Prevent navigation to "/departments"
    setIsDropdownOpen(!isDropdownOpen);
  };

  return (
    <nav className={`Navbar ${isMenuOpen ? "open" : ""}`}>
      {/* Logo Section */}
      <div className="logo">
        <img src="/images/logo.png" alt="Logo" />
      </div>

      {/* Menu Toggle Button */}
      <button className="menu-toggle" onClick={handleMenuToggle}>
        {isMenuOpen ? "✖" : "☰"}
      </button>

      {/* Navigation Menu */}
      <ul className={`menu ${isMenuOpen ? "show" : ""}`}>
        <li><a href="/">Home</a></li>
        <li className={`dropdown ${isDropdownOpen ? "open" : ""}`}>
          <a href="/departments" onClick={handleDropdownToggle}>
            Departments
          </a>
          <ul className="dropdown-menu">
            <li><a href="/">IT Department</a></li>
          </ul>
        </li>
        <li><a href="/services">Citizen Services</a></li>
        <li><a href="/about">About</a></li>
        <li><a href="/announcements">Announcements</a></li>
      </ul>
    </nav>
  );
}

export default Navbar;
